import React from "react";
import { company } from "../mock";
import PageHero from "../components/PageHero";

const sections = [
  { h: "1. Overview", p: [`This Privacy Policy explains how ${company.name} collects, uses and protects the information you share with us when you use our website or request a site visit. By using our services, you agree to the practices described here.`] },
  { h: "2. Information we collect", p: ["When you book a site visit or contact us, we may collect your name, email, phone number, company details, site address and any information you provide about your premises. We also collect basic technical data such as browser type and pages visited to improve our website."] },
  { h: "3. How we use your information", p: ["We use your details to confirm eligibility, arrange and conduct site visits, install and service machines, respond to enquiries, and keep you informed about your booking. We do not sell your personal information to third parties."] },
  { h: "4. Sharing your information", p: ["We may share information with trusted service partners (for example, installation or logistics teams) strictly to deliver the service you requested. These partners are required to protect your data and use it only for that purpose."] },
  { h: "5. Data security", p: ["We take reasonable technical and organisational measures to safeguard your information against loss, misuse and unauthorised access. No online transmission is ever completely secure, but we work hard to protect your data."] },
  { h: "6. Your rights", p: [`You may request access to, correction of, or deletion of your personal information at any time. To make a request, email us at ${company.email}.`] },
  { h: "7. Cookies", p: ["Our website may use essential cookies to keep it working smoothly. You can control cookies through your browser settings, though some features may not function correctly if disabled."] },
  { h: "8. Contact", p: [`Questions about this policy? Reach us at ${company.email} or ${company.phone}.`] }
];

export default function Privacy() {
  return (
    <main>
      <PageHero eyebrow="Legal" title="Privacy Policy" subtitle="How we handle and protect your information." />
      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-sm text-muted-foreground">Last updated: July 2025</p>
          <div className="mt-8 space-y-8">
            {sections.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-xl text-ink">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="mt-3 text-[15px] text-muted-foreground leading-relaxed">{para}</p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
